import io from 'socket.io-client';
import UserStore from '@stores/userStore';

const wsUri = process.env.REACT_APP_GPU_SOCKET_URI as string;

class EstimationProgressSocketUtil {
  private io: SocketIOClient.Socket;
  private stack: string[];

  constructor() {
    this.io = io(wsUri, { autoConnect: false });
    this.stack = [];

    this.io.on('connect', () => this.onConnect());
    this.io.on('disconnect', () => this.onDisconnect());
    this.io.on('video_progress', this.onProgress);
    this.io.on('video_progress_end', this.onProgressEnd);
  }

  private onConnect() {
    UserStore.gpuSocketConnected = true;

    if (this.stack.length) {
      window.setTimeout(() => {
        this.stack.forEach((id) => this.subscribeVideo(id));
      }, 100);
    }
  }

  private onProgress(message: string) {
    const channelId = message.split('|')[0];
    const videoId = message.split('|')[1];
    const data = message.split('|')[2];

    if (channelId && videoId && data) {
      if (videoId in UserStore.currentlyProcessingVideoDatas) {
        const chapterIdx = parseInt(data.split('=')[0]);
        const progress = parseInt(data.split('=')[1]);

        if (progress > 0) UserStore.updateProgressProcessingVideo(videoId, chapterIdx, progress);
      } else {
        console.log('Unknown Video.');
      }
    } else {
      console.log('Message is unreadable.');
    }
  }

  private onProgressEnd(message: string) {
    const videoId = message.substring(9, 20);

    UserStore.completeProgressProcessingVideo(videoId);
  }

  private onDisconnect() {
    UserStore.gpuSocketConnected = false;
  }

  public socket(): SocketIOClient.Socket {
    return this.io;
  }

  public connect() {
    this.io.connect();
  }

  public subscribeVideo(videoId: string) {
    if (this.io.connected) {
      this.io.emit('subscribe', videoId);
    } else {
      this.stack.push(videoId);
    }
  }

  public disconnect() {
    this.io.disconnect();
  }
}

export default new EstimationProgressSocketUtil();
